import React from "react";
import { FontWeightEnum } from "../../../types/AppTypes";
import { SyledFontWeight } from "../SyledFontWeight.styled";
import { StyledButtonsTyp } from "./ButtonTypography.styled";
import { ButtonSizes } from "../../core/Button/Button";

type ButtonTypographyProps = {
  fontWeight?: FontWeightEnum;
  size?: ButtonSizes;
  children: React.ReactNode;
  color?: string;
};

export const ButtonTypography = ({
  fontWeight,
  size,
  children,
  color,
}: ButtonTypographyProps) => {
  return (
    <SyledFontWeight $fontWeight={fontWeight}>
      <StyledButtonsTyp $size={size} color={color}>
        {children}
      </StyledButtonsTyp>
    </SyledFontWeight>
  );
};
